import React from 'react';
import styles from '../Style/Notifications.module.scss';

interface IProps {
  title: string;
}

const MikeNotificationTitle = (props: IProps) => {
  const { title } = props;

  return <div className={styles.mikeNotificationTitle}>{title}</div>;
};

export default React.memo(MikeNotificationTitle);
